import React, { useState } from 'react';
import classNames from 'classnames';
import { MessageQuestionIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { IResultQuestion } from 'modules/mavzuli-test';

import { FeedbackModal, MathJaxContext } from 'components';

interface IProps {
  test?: IResultQuestion;
  testName?: string;
  currentQuestion?: number;
  questionsLength?: number;
  onAnswer?: (questionId: number) => void;
}

const ResultQuizCard: React.FC<IProps> = ({ test, testName, currentQuestion, questionsLength }) => {
  const t = useTranslations();
  const [open, setOpen] = useState(false);

  const options = [
    { label: 'A', value: test?.var_a_name, id: test?.var_a_id },
    { label: 'B', value: test?.var_b_name, id: test?.var_b_id },
    { label: 'C', value: test?.var_c_name, id: test?.var_c_id },
    { label: 'D', value: test?.var_d_name, id: test?.var_d_id }
  ];

  return (
    <div>
      <div className="shadow-xs mb-3 rounded-xl bg-white px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="text-xs text-gray-500">
            {currentQuestion}/{questionsLength} • {testName}
          </div>
          <div className="flex items-center gap-2">
            {test?.checked === 0 && (
              <div className=" rounded-lg bg-gray-200 px-3 py-0.5 text-xs text-gray-700">{t('belgilanmagan')}</div>
            )}
            <div onClick={() => setOpen(true)} className="flex cursor-pointer items-center gap-2 text-orange-400">
              <MessageQuestionIcon />
              <span className="text-sm">{t('xatolik_topdim')}</span>
            </div>
          </div>
        </div>
        <div className="text-md mt-3 font-medium">
          <MathJaxContext expression={test?.question_name} />
        </div>
      </div>
      <div className="shadow-xs mb-4 rounded-xl bg-white px-4 py-3">
        <div className="space-y-3">
          {options?.map(option => {
            const isCorrect = test?.correct === option.id;
            const isChecked = test?.checked === option.id;

            let borderColor = 'border-gray-200';

            if (test?.checked === 0) {
              if (isCorrect) borderColor = 'border-green-500';
            } else if (isCorrect && isChecked) {
              borderColor = 'border-green-500';
            } else if (isCorrect) {
              borderColor = 'border-green-500';
            } else if (isChecked) {
              borderColor = 'border-red-500';
            }

            return (
              <div key={option.id} className={classNames('rounded-xl border-2', borderColor)}>
                <div className="flex items-center gap-3 rounded-xl p-3 transition-all">
                  <span className="font-semibold text-gray-600">{option.label})</span>
                  <p className="text-sm text-gray-800">
                    <MathJaxContext expression={option.value} />
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <FeedbackModal questionId={test?.question_id} open={open} onClose={() => setOpen(false)} />
    </div>
  );
};

export default ResultQuizCard;
